import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";

const Footer = () => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "60px",
          bgcolor: "black",
        }}
      >
        <Typography varinat="body1" color="white" fontWeight="bold">
          2021 || Rabbi Hasan. All rights reserved
        </Typography>
      </Box>
    </>
  );
};

export default Footer;
